import React, { useCallback } from 'react';
import { FormGroup } from 'src/components/ui';
import Switch from '../Switch';
import FieldTitle from './common/FieldTitle';
import useTestId from '../../hooks/useTestId';

function SwitchField(props) {
  const {
    formData,
    readonly: propReadonly,
    disabled,
    uiSchema: { 'ui:readonly': uiReadonly, 'ui:color': color = 'secondary', 'ui:checkedColor': checkedColor = 'info', 'ui:round': round = true },
    onChange: propOnChange,
    fieldPathId: { path, $id },
  } = props;
  const testIdProps = useTestId($id);

  const readonly = propReadonly || uiReadonly || disabled;

  const onChange = useCallback(({ target: { checked } }) => {
    if (readonly) return;
    propOnChange(!!checked, path);
  }, [readonly]);

  const checked = !!formData;

  return (
    <FormGroup disabled={readonly || disabled}>
      <Switch
        className={`switch-${!readonly && checkedColor && checked ? checkedColor : color}`}
        readonly={readonly}
        round={round}
        value={checked}
        onChange={onChange}
        {...testIdProps}
      />
      <FieldTitle {...props} />
    </FormGroup>
  );
}

export default SwitchField;
